// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","footerBtn":"reports-journal_footerBtn__zcd8I","btn":"reports-journal_btn__Ptbh5","icon":"reports-journal_icon__QpXQn"};